import React from "react"
import { useStaticQuery, graphql } from "gatsby";
import styled from "styled-components";

import { MapContextProvider } from "../context/mapContext";

import { useLoadScript } from "@react-google-maps/api";

import BigMap from "./BigMap";

import { rhythm, scale } from "../utils/typography"

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-wrap: wrap;
`

const MapNav = styled.nav`
  flex-grow: 2;
  height: 100%;
  flex-basis: 320px;
  @media (max-width: 640px) {
    height: 50% !important;
  }
`

const MainWrapper = styled.div`
  padding: 2em;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-basis: 320px;
  flex-grow: 1;
  overflow-y: scroll;
`

const Main = styled.main`
  flex-grow: 1;
`

function Layout({children}) {

  console.log(process.env.GATSBY_MAPS_API_KEY);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.GATSBY_MAPS_API_KEY
  })

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
      allMarkdownRemark(sort: { fields: [frontmatter___date], order: ASC }) {
        edges {
          node {
            excerpt
            fields {
              slug
            }
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              title
              description
              longitude
              latitude
              location
            }
          }
        }
      }
    }
  `);

  const posts = data.allMarkdownRemark.edges

  return (
    <MapContextProvider>
      <LayoutContainer>
        <MapNav>
          {isLoaded && <BigMap posts={posts}></BigMap>}
        </MapNav>
        <MainWrapper>
          <Main>
            {children}
          </Main>
          <footer>
          © Build with ❤️ in Bonn
          </footer>
        </MainWrapper>
      </LayoutContainer>
    </MapContextProvider>
  )
}

export default Layout
